/**
 * ページ閲覧の計測と、Clarity（操作の録画）の範囲の切り替え（family-design/analytics.ts）。
 * 録画するのは、ログインしていない人が公開ページにいる間だけ。トークン付きの再設定・確認ページは除く。
 * Clarity は URL をクエリごと送るので、紹介コード（ref）や戻り先（return）など、下の一覧にないクエリが付いた URL も録画しない。
 * 録画は読み込んだ最初のページだけ。SPA で別の URL へ移る直前と、ログインした時点（描画の前）に止め、読み込み直すまで再開しない。
 * 範囲を変えたらプライバシーポリシーの Cookie ポリシー 3 項も直す。
 */
import { useEffect, useLayoutEffect } from 'react'
import { useLocation } from 'react-router-dom'
import { useAuth } from '../contexts/AuthContext'
import { trackPage, setRecording } from '../../../family-design/analytics'

const RECORDED = new Set(['/', '/login', '/signup', '/pricing', '/genemo', '/terms', '/privacy', '/legal/specified-commercial'])
const SAFE_QUERY = new Set(['plan', 'interval', 'oauth', 'stripe', 'error'])
const isRecordable = (pathname: string, search: string) =>
  RECORDED.has(pathname.replace(/\/+$/, '') || '/') && [...new URLSearchParams(search).keys()].every(k => SAFE_QUERY.has(k))

export function AnalyticsTracker() {
  const { pathname, search } = useLocation()
  const { user, isLoading } = useAuth()

  useEffect(() => { trackPage(pathname) }, [pathname])

  // 描画より先に止めるため useLayoutEffect（ログイン直後の画面を録画に残さない）
  useLayoutEffect(() => {
    if (!isLoading) setRecording(!user && isRecordable(pathname, search))
  }, [user, isLoading, pathname, search])

  return null
}
